import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}


// Removed by Joey S @ Shopify Theme Support 03 February 2026 | Reverted cart-drawer
/*
class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

const CART_REFRESH_EVENT = 'cart:refresh-drawer';

class CartDrawerManager extends HTMLElement {
  connectedCallback() {
    document.addEventListener(CART_REFRESH_EVENT, this.#handleRefresh);
  }

  disconnectedCallback() {
    document.removeEventListener(CART_REFRESH_EVENT, this.#handleRefresh);
  }

  #handleRefresh = () => {
    const cartList = this.querySelector('.previewCartList');
    if (!cartList) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        fetch((window.routes?.root || '') + '/cart?view=ajax_side_cart')
          .then(res => res.text())
          .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const newList = temp.querySelector('.previewCartList');
            if (newList) cartList.innerHTML = newList.innerHTML;
            document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
            document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
          });
      });
  };

  refresh() {
    document.dispatchEvent(new CustomEvent(CART_REFRESH_EVENT, { bubbles: true }));
  }
}

if (!customElements.get('cart-drawer-manager')) {
  customElements.define('cart-drawer-manager', CartDrawerManager);
}

window.refreshCartDrawer = () => {
  document.dispatchEvent(new CustomEvent(CART_REFRESH_EVENT, { bubbles: true }));
};
*/
// End of Removed Code